import { render, staticRenderFns } from "./GatewayActList.vue?vue&type=template&id=a583911e&"
import script from "./GatewayActList.vue?vue&type=script&lang=js&"
export * from "./GatewayActList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports